export default "__VITE_ASSET__AfYgaOB4__"